export interface ActionConfig {
  action: string;
  label: string;
  icon?: string;
  tooltip?: string;
  disabled?: boolean | ((rowData: any) => boolean);
  visible?: boolean | ((rowData: any) => boolean);
  cssClass?: string;
  columnWidth?: number;
  iconposition?: 'Left' | 'Right';
}

const DEFAULT_ACTIONS: ActionConfig[] = [
  {
    action: 'view',
    label: 'View',
    icon: 'material-icons',
    tooltip: 'View details',
    cssClass: 'btn-view',
  },
  {
    action: 'edit',
    label: 'Edit',
    icon: 'material-icons',
    tooltip: 'Edit record',
    cssClass: 'btn-edit',
  },
  {
    action: 'delete',
    label: 'Delete',
    icon: 'material-icons',
    tooltip: 'Delete record',
    cssClass: 'btn-delete',
  },
];

export const ACTION_CONFIGS = {
  DEFAULT: DEFAULT_ACTIONS,
};

export const getActionsForPreset = (
  preset: keyof typeof ACTION_CONFIGS,
): ActionConfig[] => {
  return ACTION_CONFIGS[preset] || ACTION_CONFIGS.DEFAULT;
};

export { DEFAULT_ACTIONS };
